module.exports = __webpack_public_path__ + "static/img/left-bottom-row-2.b949423c.webp";